/**
 * Base css generation and global js logic.
 */
/* eslint-disable */
import 'tokens/sass/tokens.scss';

const head = document.getElementsByTagName('head')[0];


const updateQueryParams = function() {
  const urlParams = new URLSearchParams(window.location.search);
  var links = document.querySelectorAll('.language-switcher-language-url a.language-link');
  // remove pager informations
  urlParams.delete('field_result');
  const linkQuery = JSON.stringify(Object.fromEntries(urlParams));
  links.forEach((el) => {
    const href = new URL(el.href);
    href.search = urlParams;
    el.setAttribute('href', href.toString());
    el.setAttribute('data-drupal-link-query', linkQuery);
    el.parentNode.setAttribute('data-drupal-link-query', linkQuery);
  });
};
const updateQuery = function(){
  setTimeout(updateQueryParams, 500);

}

window.addEventListener('DOMContentLoaded', (event) => {
  updateQuery();
});

/**
 * e.g. React uses pushState to update the url. pushState will never fire any event itself
 * so we override this function to be able to listen to any changes
 */
(function(history){
  var pushState = history.pushState;
  history.pushState = function(state) {
    if (typeof history.onpushstate == "function") {
      history.onpushstate({state: state});
    }
    updateQuery();
    return pushState.apply(history, arguments);
  }
})(window.history);

/*
  Save the original method
  deny loading google fonts which might be dynamilly loaded adn added to header  in e.g. google-maps
 */
const insertBefore = head.insertBefore;
head.insertBefore = function (newElement, referenceElement) {
  if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css') > -1) {
    return;
  }
  insertBefore.call(head, newElement, referenceElement);
};
/* eslint-enable */

// Export global variables.
export default {
  // Demo only, remove in practice
  GLOBAL_CONSTANT: 'particle',
};
